import {combineReducers, createStore} from "redux";
import {routerReducer} from "react-router-redux";

let initialState = {
    user: null,
    currentVideo: null,
    modules: null,
    open: [],
    miscVideos: {},
    collapse: {},
    alerts: [],
    cookieChecker: false,
    notification: 0,
    replies: [],
    banlist: [],
    online: 0,
    comments: new Set(),
    searchTerm: ''
};
let replaceArrayOnAction = function (prevState, action, type) {
    if (action.type === type) {
        return action.value.slice();
    }
    return prevState;
};
let replaceObjOnAction = function (prevState, action, type) {
    if (action.type === type) {
        return action.value;
    }
    return prevState;
};
let mergeObjOnAction = function (prevState, action, type) {
    if (action.type === type) {
        if (action.value === null)
            return null;
        return Object.assign({}, prevState, action.value);
    }
    return prevState;
};
let reducers = {
    user: function (prevState = null, action) {
        return mergeObjOnAction(prevState, action, 'gotUser');
    },
    miscVideos: function (prevState = null, action) {
        return replaceObjOnAction(prevState, action, 'miscVideos');
    },
    currentVideo: function (prevState = null, action) {
        return replaceObjOnAction(prevState, action, 'currentVideo');
    },
    promoVideos: function (prevState = null, action) {
        return replaceArrayOnAction(prevState, action, 'promoVideos');
    },
    modules: function (prevState = null, action) {
        if (action.type === 'clearModules')
            return replaceObjOnAction(prevState, action, 'clearModules');
        if (action.type === 'modules')
            return replaceArrayOnAction(prevState, action, 'modules');
        else if (action.type === 'moduleVideoList' && prevState && prevState.find
            && prevState.find(m => m.ID === action.value.ID)) {
            let newModules = prevState.slice();
            newModules.find(m => m.ID === action.value.ID).moduleVideoList = action.value.moduleVideoListObj;
            return newModules;
        } else {
            return prevState;
        }
    },
    open: function (prevState = [], action) {
        if (action.type === 'openMod') {
            return replaceArrayOnAction(prevState, action, 'openMod');
        } else if (action.type === 'openVideoList' && prevState && prevState.find
            && prevState.find(m => m.ID === action.value.ID)) {
            let newModules = prevState.slice();
            newModules.find(m => m.ID === action.value.ID).moduleVideoList = action.value.moduleVideoListObj;
            return newModules;
        } else {
            return prevState;
        }
    },
    searchTerm: function (prevState = '', action) {
        if (action.type === 'searchTerm') {
            return action.value;
        }
        return prevState;
    },
    alerts: function (prevState = [], action) {
        if (!action.value) return prevState;
        if (action.type === 'addAlert') {
            function guid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            }
            let alerts = prevState.slice();
            let alert = action.value;
            alert.id = guid();
            return alerts.concat([alert]);
        } else if (action.type === 'removeAlert') {
            let alerts = prevState.slice();
            let idx = alerts.findIndex((e)=>e.id === action.value.id);
            if (idx >= 0) {
                alerts.splice(idx, 1);
            }
            return alerts;
        } else {
            return prevState;
        }
    },
    collapse: function (prevState = {}, action) {
        if (action.type === 'collapse') {
            return Object.assign({}, prevState, action.value);
        } else if (action.type === 'clearCollapse') {
            return action.value;
        } else if (action.type === 'clearOpenCollapse') {
            let newState = Object.assign({}, prevState);
            for (let key in newState) {
                if (key.startsWith('open'))
                    delete newState[key];
            }
            return newState;
        } else if (action.type === 'collapseByModID') {

        } else {
            return prevState;
        }
    },
    cookieChecker: function (prevState = false, action) {
        return replaceObjOnAction(prevState, action, 'cookieChecker');
    },
    notification: function (prevState = 0, action) {
        return replaceObjOnAction(prevState, action, 'notification');
    },
    replies: function (prevState = [], action) {
        return replaceObjOnAction(prevState, action, 'replies');
    },
    banlist: function (prevState = [], action) {
        return replaceObjOnAction(prevState, action, 'banlist');
    },
    online: function (prevState = 0, action) {
        return replaceObjOnAction(prevState, action, 'online');
    },
    comments: function (prevState = new Set(), action) {
        if (action.type === 'addComment') {
            let set = prevState;
            set.add(action.value);
            return set;
        } else if (action.type === 'removeComment') {
            let set = prevState;
            set.delete(action.value);
            return set;
        } else if (action.type === 'clearComment') {
            return new Set();
        } else {
            return prevState;
        }
    }
    // loginModal: function (prevState = {}, action) {
    //     if (action.type === 'loginModal') {
    //         if (action.value === true || action.value === false)
    //             return Object.assign({}, prevState, {show: action.value});
    //         else
    //             return Object.assign({}, prevState, action.value);
    //     } else {
    //         return prevState;
    //     }
    // }
};
let store = createStore(combineReducers({
    ...reducers,
    routing: routerReducer
}), initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export default store;


// WEBPACK FOOTER //
// ./src/store.js